import { TranslationService } from '@sdbn/common';
import { Component } from '@angular/core';
import { ContextChange, WidgetStyle } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { HttpService } from '@sdbn/appclient';

@Component({
  selector: 'app-export-visitor-log-widget',
  templateUrl: './export-visitor-log-widget.component.html'
})
export class ExportVisitorLogWidgetComponent extends AbstractWidgetComponent {

  constructor(
    public translationService: TranslationService,
    private http: HttpService
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
